import { registerCustomControlProvider } from '../registry';
import { buildObjectActionsButtons } from './shared';

registerCustomControlProvider({
  id: 'generic-object-floating-controls',
  match: (object) => {
    if (!object) return false;
    if (object.type === 'MagicFrame') return false;
    if (object.type === 'image' && object._magicFrame) return false;
    if (object.type === 'textbox' || object.type === 'i-text') return false;
    return true;
  },
  create: (manager, object) => {
    const options = {
      offsetY: 0,
      offsetX: 0,
      gap: 12,
      initialView: 'home',
      views: {
        home: {
          buttons: [
            {
              text: 'Azioni',
              inlineSvg:
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"></path></svg>',
              className: 'btn-customize',
              children: buildObjectActionsButtons(() => object),
            },
          ],
        },
      },
    };

    return manager.createFloatingControls(object, options);
  },
});
